var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 523,
    height: 571,
    viewBox: "0 0 523 571",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.8 75.2749C542.817 80.7858 475.793 104.789 479.563 156.714C484.275 221.62 587.081 262.238 612.782 323.471C631.752 368.665 629.06 481.858 513.403 529.416",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.935 69.6543C489.952 75.1652 422.928 99.1683 426.697 151.093C431.409 216 534.216 256.617 559.917 317.85C578.887 363.044 576.195 476.238 460.538 523.795",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.294 66.0896C436.311 71.6005 369.287 95.6036 373.057 147.529C377.769 212.435 480.575 253.053 506.277 314.285C525.246 359.479 522.554 472.673 406.897 520.23",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.23 64.5361C382.247 70.0471 315.223 94.0502 318.992 145.975C323.704 210.882 426.511 251.499 452.212 312.732C471.182 357.926 468.49 471.12 352.833 518.677",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.076 64.9146C328.092 70.4255 261.069 94.4286 264.838 146.354C269.55 211.26 372.356 251.878 398.058 313.11C417.027 358.304 414.335 471.498 298.678 519.055",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.113 67.1226C274.13 72.6335 207.106 96.6366 210.875 148.562C215.587 213.468 318.393 254.086 344.095 315.318C363.065 360.512 360.373 473.706 244.716 521.263",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.581 71.0471C220.598 76.558 153.574 100.561 157.344 152.486C162.056 217.393 264.862 258.01 290.564 319.243C309.533 364.437 306.841 477.631 191.184 525.188",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.677 76.5754C167.694 82.0864 100.67 106.089 104.44 158.015C109.152 222.921 211.958 263.539 237.659 324.771C256.629 369.965 253.937 483.159 138.28 530.716",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.562 83.6033C115.579 89.1142 48.5549 113.117 52.3244 165.042C57.0364 229.949 159.843 270.566 185.544 331.799C204.514 376.993 201.822 490.187 86.1648 537.744",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3901 92.0422C64.4069 97.5532 -2.617 121.556 1.15256 173.481C5.86451 238.388 108.671 279.005 134.372 340.238C153.342 385.432 150.65 498.626 34.9929 546.183",
    stroke: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDWaves);
export default __webpack_public_path__ + "static/media/D-waves.e3e26196822b24f2f9c732aa2eaa3700.svg";
export { ForwardRef as ReactComponent };